<template>
    <div class="card card-blue">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <h4 class="m-b-0"><i class="fas fa-file-signature"></i> Contract Overview</h4>
                </div>
                <div class="col-md-6 text-right"
                     v-if="contract.status === 'DRAFT' && contract.marketplace_id === currentOrg.marketplace_id">
                    <div class="button-group">
                        <a class="btn btn-success waves-effect waves-light" data-target="#contractOverview"
                           data-toggle="modal" href="javasript:void(0);">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt v-if="contract.type === 'SALE'">Seller</dt>
                            <dt v-if="contract.type === 'PURCHASE'">Buyer</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1"><a href="">{{contract.owner.biz_name}}</a></dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt v-if="contract.member_did && contract.member_catalog">Member</dt>
                            <dt v-else-if="contract.type === 'PURCHASE'">Seller</dt>
                            <dt v-else-if="contract.type === 'SALE'">Buyer</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd v-if="contract.member_did && contract.member_catalog">
                                <did-details class="mt-0" :catalog="contract.member_catalog" :did="contract.member_did"
                                             :show_blockie="false"></did-details>
                            </dd>
                            <dd class="mb-1" v-else><a href="">{{contract.counterparty.biz_name}}</a></dd>
                        </div>
                    </dl>
                </div>
                <div class="col-lg-6">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Created</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{contract.created_at | date}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Expiry Date</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{contract.expires_at | date}}</dd>
                        </div>
                    </dl>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6" id="cluster_info">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Contract Type</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{contract.type | capitalize}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Audit</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">
                                <a :href="contract.audit" target="_blank" v-if="contract.audit">{{
                                    contract.audit }}</a>
                                <span v-else>NA</span>
                            </dd>
                        </div>
                    </dl>
                </div>
                <div class="col-lg-6" id="provenance_info">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Provenance</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">
                                <a :href="contract.provenance" target="_blank" v-if="contract.provenance">{{
                                    contract.provenance }}</a>
                                <span v-else>NA</span>
                            </dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Trade</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">
                                <router-link :to="{name: 'viewtrade', params: {tradeid: contract.trade_ref}}"
                                             v-if="contract.trade_ref">{{contract.trade_ref}}
                                </router-link>
                                <span v-else>NA</span>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>


        <div aria-labelledby="contractOverview" class="modal fade" id="contractOverview" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="card-body">
                            <h4 class="card-title">Contract Overview</h4>
                            <h5 class="card-subtitle">Overview of contract type, parties, products, prices</h5>
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class="tab-pane active" id="properties" role="tabpanel">
                                    <div class="row m-t-20">
                                        <div class="col-md-12">
                                            <form>
<!--                                                <div class="col-sm-12 col-lg-12 m-t-20">-->
<!--                                                    <div class="form-group row">-->
<!--                                                        <label class="col-sm-2 text-right control-label col-form-label"-->
<!--                                                               v-if="contract.type === 'PURCHASE'">Buyer</label>-->
<!--                                                        <label class="col-sm-2 text-right control-label col-form-label"-->
<!--                                                               v-if="contract.type === 'SALE'">Seller</label>-->
<!--                                                        <div class="col-sm-8">-->
<!--                                                            <p class="form-control" readonly style="height: 42px">-->
<!--                                                                {{contract.owner.biz_name}}</p>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                                <div class="col-sm-12 col-lg-12 m-t-20">-->
<!--                                                    <div class="form-group row">-->
<!--                                                        <label class="col-sm-2 text-right control-label col-form-label"-->
<!--                                                               v-if="contract.type === 'SALE'">Buyer</label>-->
<!--                                                        <label class="col-sm-2 text-right control-label col-form-label"-->
<!--                                                               v-if="contract.type === 'PURCHASE'">Seller</label>-->
<!--                                                        <div class="col-sm-8">-->
<!--                                                            <p class="form-control" readonly style="height: 42px">-->
<!--                                                                {{contract.counterparty.biz_name}}</p>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                                <div class="col-sm-12 col-lg-12 m-t-20">-->
<!--                                                    <div class="form-group row">-->
<!--                                                        <label class="col-sm-2 text-right control-label col-form-label">Creation-->
<!--                                                            Date</label>-->
<!--                                                        <div class="col-sm-8">-->
<!--                                                            <p class="form-control" readonly style="height: 42px">-->
<!--                                                                {{contract.created_at | date}}</p>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label"
                                                               for="expiry_date">Expiry Date</label>
                                                        <div class="input-group col-sm-8">
                                                            <div class="input-group-prepend date">
                                                                <span class="input-group-text"><i
                                                                        class="fa fa-calendar"></i></span>
                                                            </div>
                                                            <input autocomplete="off"
                                                                   class="form-control"
                                                                   data-vv-as="expiry_date"
                                                                   id="expiry_date"
                                                                   name="expiry_date"
                                                                   placeholder="dd/mm/yyyy"
                                                                   style="height: 42px"
                                                                   type="text"
                                                                   v-model="editContract.expires_at">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Provenance</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Provenance"
                                                                   style="width: 250px; height: 42px;"
                                                                   type="text"
                                                                   v-model="editContract.provenance"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Audit</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Audit"
                                                                   name="audit"
                                                                   placeholder="Audit"
                                                                   style="height: 42px;"
                                                                   type="text"
                                                                   v-model="editContract.audit"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="update" class="btn waves-effect waves-light btn-success" data-dismiss="modal"
                                type="submit">Submit
                        </button>
                        <button class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import UnitSelect from "../../common/UnitSelect";
    import CurrencySelect from "../../../protected/common/CurrencySelect";
    import {mapGetters} from "vuex";
    import DidDetails from "../../common/DidDetails";
    import Blockie from "../../common/Blockie";

    export default {
        name: "MarketplaceContractOverview",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, DidDetails, Multiselect, UnitSelect, CurrencySelect},
        props: {
            contract: Object
        },
        data() {
            return {
                submitted: false,
                editContract: {
                    expires_at: null,
                    provenance: null,
                    audit: null
                },
                explorer: null,
            }
        },
        mounted() {
            console.log(this.currentUser, this.currentOrg)
            this.explorer = this.$EXPLORER;
            this.init();
        },
        methods: {
            async init() {
                this.editContract.id = this.contract.id;
                this.editContract.expires_at = this.contract.expires_at ? moment(this.contract.expires_at).format("MM/DD/YYYY") : null;
                jQuery('#expiry_date').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.editContract.expires_at = event.target.value;
                });
                this.editContract.provenance = this.contract.provenance;
            },
            async update() {
                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/${this.contract.id}/updateprops`, this.editContract);
                    // this.$root.$emit('refreshContract');
                    this.$toastr('success', 'Contract updated successfully', 'Contract Updation');
                    // await this.$router.push({name: "view-marketplace-contract", params: {contractid: this.contract.id}});
                    await this.$parent.getContract();
                } catch (e) {
                    console.error(e)
                }
            }
        }
    }
</script>

<style scoped>

</style>
